import bridge from '@utiles/officialStore/bridge';
import globalConfig from '@utiles/officialStore/globalConfig';
export default {
  computed: {
    isAutoMatchProduct() {
      return this.$store.state.isAutoMatchProduct;
    },
    isTransparentBgMode() {
      if (
        globalConfig.getHrefParam('isClearBg') === '1' &&
        bridge.runInsdk() &&
        this.isAutoMatchProduct
      ) {
        return true;
      }
      return false;
    }
  }
};
